import React, { useState, useEffect } from 'react';
import './AvatarSettings.css';
import UserHeader from "../../components/header/UserHeader";
import UserDrawer from "../../components/drawer/UserDrawer";
import { Row, Col, notification, Button } from "antd";
import goBackButton from "../../assets/images/Go_Back.svg";
import amyImage from '../../assets/images/my-friend-logo.png';
import arthurImage from '../../assets/images/my-frieind-logo2.svg';
import samImage from '../../assets/images/Sam_Logo.png';
import { UploadOutlined } from '@ant-design/icons';
import { AvatarUploadModal } from './AvatarUploadModal.js';
import { useLocation, useNavigate } from 'react-router-dom';
import { addAvatarData, avatarPresignedUrl, getUserBots } from '../../api/Avatar.js';

const ChangeAvatarImage = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [selectedVoice, setSelectedVoice] = useState('');
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [isUploadModalVisible, setIsUploadModalVisible] = useState(false);
    const [selectedBotName, setSelectedBotName] = useState('');
    const navigate = useNavigate();
    const location = useLocation();
    const { userId } = location.state || {};
    const [botsData, setBotsData] = useState({});

    const fetchBotsData = async () => {
        try {
            const response = await getUserBots();
            if (response.success) {
                setBotsData(response.data.reduce((acc, { botName, imageUrl }) => {
                    acc[botName] = imageUrl;
                    return acc;
                }, {}));
            }
        } catch (error) {
            console.error('Error fetching bot data:', error);
            notification.error({
                message: 'Error fetching bot data',
                description: error.message,
            });
        }
    };

    useEffect(() => {
        fetchBotsData();
    }, []);

    const handleUploadClick = (botName) => {
        setSelectedBotName(botName);
        setIsUploadModalVisible(true);
    };

    const handleAvatarSelect = async ({ botName, imageUrl, file }) => {
        setIsLoading(true);
        try {
            let finalImageUrl = imageUrl;

            if (file) {
                if (!['image/png', 'image/jpeg', 'image/jpg', 'image/gif'].includes(file.type)) {
                    notification.error({
                        message: 'Invalid File Type',
                        description: 'Please upload an image file with extension PNG, JPEG, JPG, or GIF.'
                    });
                    return;
                }

                const presignedResponse = await avatarPresignedUrl({ fileType: file.type });

                if (presignedResponse.error) {
                    throw new Error(presignedResponse.error);
                }

                await fetch(presignedResponse.uploadUrl, {
                    method: 'PUT',
                    body: file,
                    headers: {
                        'Content-Type': file.type
                    }
                });

                finalImageUrl = presignedResponse.fullImageUrl;
            }

            const response = await addAvatarData({
                botName,
                imageUrl: finalImageUrl
            });

            if (response.error) {
                throw new Error(response.error);
            }

            notification.success({
                message: 'Avatar Updated',
                description: 'Avatar updated successfully!'
            });

            await fetchBotsData();

        } catch (error) {
            notification.error({
                message: 'Update Failed',
                description: error.message || 'Failed to update avatar'
            });
        } finally {
            setIsLoading(false);
        }
    };

    const handleGoBackButton = () => {
        navigate("/landing-page", { state: { userId } });
    };
    const sectionsContainerStyle = {
        transition: "opacity 0.3s ease, pointer-events 0.3s ease",
        opacity: isDrawerOpen ? "0.5" : "1",
        pointerEvents: isDrawerOpen ? "none" : "auto",
    };

    const openDrawer = () => {
        setIsDrawerOpen(true);
    };

    const closeDrawer = () => {
        setIsDrawerOpen(false);
    };

    return (
        <div style={{ minHeight: "100dvh", background: "#fefcfe" }}>
            <Col xs={24} sm={24} lg={24} md={24} style={sectionsContainerStyle}>
                <Row
                    justify={{
                        xs: "space-around",
                        md: "space-around",
                        lg: "space-between",
                    }}
                    style={{ marginBottom: 20 }}
                >
                    <Col xs={{ span: 22 }} lg={{ span: 24 }} md={{ span: 22 }}>
                        <UserHeader setDrawer={openDrawer} />
                    </Col>
                    {isDrawerOpen && (
                        <Col span={4}>
                            <UserDrawer isDrawerOpen={isDrawerOpen} onClose={closeDrawer} />
                        </Col>
                    )}
                    <Col flex="10%" className="go-back-button">
                        <button onClick={handleGoBackButton} className="button-styling">
                            <img src={goBackButton} alt="Go Back Button" />
                        </button>
                    </Col>
                </Row>
                <div className="avatar-settings-container">
                    <h2 className='avatar-heading'>Change Avatar Images</h2>

                    <div className="section">
                        <div className="section-title-margin-left">CHOOSE YOUR AVATAR IMAGE OR UPLOAD MANUALLY</div>
                        <div className="avatar-options">
                            {['Arthur', 'Amy', 'Sam'].map((botName) => {
                                const imageUrl = botsData[botName] || (botName === 'Arthur' ? arthurImage : botName === 'Amy' ? amyImage : samImage);
                                return (
                                    <div className={`avatar-option ${selectedVoice === botName ? 'selected' : ''}`} key={botName}>
                                        <div className="change-avatar-image">
                                            <img src={imageUrl} alt={botName} style={{
                                                borderRadius: '50%',
                                                width: '54px',
                                                height: '54.77px',
                                            }} />
                                        </div>
                                        <div className="avatar-details">
                                            <h4 className='avatar-name'>{botName}</h4>
                                            <p className='avatar-gender'>{botName === 'Sam' ? 'Text Conversation' : 'Voice'}</p>
                                        </div>
                                        <Button
                                            className="upload-button-styling"
                                            icon={<UploadOutlined />}
                                            onClick={() => handleUploadClick(botName)}
                                        >
                                            Upload Image of Avatar
                                        </Button>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </Col>
            <AvatarUploadModal
                visible={isUploadModalVisible}
                onClose={() => setIsUploadModalVisible(false)}
                onAvatarSelect={handleAvatarSelect}
                botName={selectedBotName}
            />
        </div>

    );
};

export default ChangeAvatarImage;
